/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import BASEUtils from '../../@BASE/utils';
import BASELoading from '../../@BASE/core/BASELoading';
import { Navigate } from 'react-router-dom';
import settingsConfig from '../configs/settingsConfig';
import SignInConfig from '../main/sign-in/SignInConfig';
import SignOutConfig from '../main/sign-out/SignOutConfig';
import Error404Page from '../main/404/Error404Page';
import ProjectsConfig from '../main/projects/ProjectsConfig';
import CoursesConfig from '../main/courses/CoursesConfig';
import LessonsConfig from '../main/lessons/LessonsConfig';
import SectionsConfig from '../main/sections/SectionsConfig';
import PagesConfig from '../main/pages/PagesConfig';
import SettingsConfig from '../main/settings/SettingsConfig';
import UsersConfig from '../main/users/UsersConfig';
import TemplatesConfig from '../main/templates/TemplatesConfig';
import ReviewsConfig from '../main/reviews/ReviewsConfig';
import OrganizationsConfig from '../main/organizations/OrganizationsConfig';
import LessonAnswers from '../main/lessons/instance/LessonAnswers';
import LessonStoryboard from '../main/lessons/instance/LessonStoryboard';
import IMICommentsConfig from '../main/imi-comments/IMICommmentsConfig';
import PreTrialCommentsConfig from '../main/pre-trial-comments/PreTrialCommmentsConfig';
import PasswordConfig from '../main/password/PasswordConfig';

const routeConfigs = [
  ProjectsConfig,
  CoursesConfig,
  LessonsConfig,
  SectionsConfig,
  PagesConfig,
  SettingsConfig,
  SignOutConfig,
  SignInConfig,
  PasswordConfig,
  IMICommentsConfig,
  PreTrialCommentsConfig
];

const routeLeadEditorConfigs = [TemplatesConfig];

const routeAdminConfigs = [UsersConfig, ReviewsConfig, OrganizationsConfig];

const routes = [
  ...BASEUtils.generateRoutesFromConfigs(
    routeConfigs,
    settingsConfig.defaultAuth
  ),
  ...BASEUtils.generateRoutesFromConfigs(
    routeLeadEditorConfigs,
    settingsConfig.leads
  ),
  ...BASEUtils.generateRoutesFromConfigs(
    routeAdminConfigs,
    settingsConfig.leads
  ),
  {
    path: '/',
    element: <Navigate to="/projects" />,
    auth: settingsConfig.defaultAuth
  },
  {
    path: 'loading',
    element: <BASELoading />,
    auth: settingsConfig.defaultAuth
  },
  {
    path: '404',
    element: <Error404Page />,
    auth: settingsConfig.defaultAuth
  },
  {
    path: '*',
    element: <Navigate to="404" />,
    auth: settingsConfig.defaultAuth
  },
  {
    path: 'lessons/:id/answers',
    element: <LessonAnswers />
  },
  {
    path: 'lessons/:id/storyboard',
    element: <LessonStoryboard />,
    auth: settingsConfig.leads
  }
];

export default routes;
